import { useRef, useState, useEffect } from "react";
import { faCheck, faTimes, faInfoCircle, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
// import Select from 'react-select';
import { useNavigate } from 'react-router-dom'; // Import useNavigate



const UPDATE_STHAN_USER = "update-sthan-user";

const UpdateSthanUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
    setMobile("");
  };
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const { personId, Name, Mobile, Responsibility } = useParams();
  const [mobile, setMobile] = useState(Mobile);
  const [name, setName] = useState(Name);
  const [responsibility, setResponsibility] = useState(Responsibility === "Nill" ? "STHAN PRAMUKH" : Responsibility);


  const [validMobile, setValidMobile] = useState(false);
  const [validName, setValidName] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  // const [success, setSuccess] = useState(false);

  useEffect(() => {
    const isValid = /^[0-9]{10}$/.test(mobile);
    setValidMobile(isValid);
  }, [mobile]);

  // useEffect(() => {
  //   const isValid = /^[\p{L}\s]{2,}$/u.test(name);
  //   // \p{L} = any kind of letter from any language
  //   // \s    = whitespace
  //   // {2,}  = at least 2 characters
  //   setValidName(isValid);
  // }, [name]);

  useEffect(() => {
    const isValid = /^(?!.*\d).{2,}$/.test(name);
    // (?!.*\d) → negative lookahead, ensures no digits 0–9
    // .{2,}    → any 2 or more characters (except newlines)
    setValidName(isValid);
  }, [name]);




  useEffect(() => {
    userRef.current.focus();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        person_id: personId,
        name,
        mobile,
        responsibility,
      });

      const response = await axiosPrivate.post(UPDATE_STHAN_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      showMessage('success', response?.data?.message);

    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}

        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

        <section className="userregbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>


          <div className="wrapper wrapper2">
            <form>
              <h3 class="arthik_head">Update Sthan User</h3>

              <div className="input-box arthik_input-box">
                <input
                  type="text"
                  id="name"
                  placeholder="Enter Name"
                  autoComplete="off"
                  ref={userRef}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  required
                  aria-invalid={validName ? "false" : "true"}
                  aria-describedby="namenote"
                />


                <small
                  className={
                    name.length >= 2 && !validName
                      ? "text-danger mt-1 d-block"
                      : "d-none"
                  }
                >
                  Name must contain only letters and be at least 2 characters long.
                </small>


              </div>

              <div className="input-box arthik_input-box">
                <input
                  type="text"
                  id="mobile"
                  placeholder="Enter Mobile number"
                  autoComplete="off"
                  ref={userRef}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                  value={mobile}
                  required
                  aria-invalid={validMobile ? "false" : "true"}
                  aria-describedby="mobilenote"
                  maxLength={10}
                />

                <small
                  className={
                    mobile && !validMobile
                      ? "text-danger mt-1 d-block"
                      : "d-none"
                  }
                >
                  Mobile number must be 10 digits!.
                </small>
              </div>


              <div className="input-box arthik_input-box">
                <input
                  type="text"
                  id="responsibility"
                  placeholder="Enter Responsibility"
                  autoComplete="off"
                  onChange={(e) => setResponsibility(e.target.value)}
                  value={responsibility}
                  required
                  aria-describedby="responsibilitynote"
                />
              </div>

              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={handleSubmit} // Call this for "Sign Up"
                disabled={!validMobile
                  || !validName
                }
              >
                Submit
              </button>
            </form>

          </div>
        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default UpdateSthanUser;
